import React from 'react';
import ReactDOM from 'react-dom'
import { Button } from 'Components';
import { LinearProgress } from '@mui/material';
// Styles
import './style.scss';
import { injectIntl } from "react-intl"; 

/**
 * InfoWindow — renders the InfoBubble portal into the CustomOverlay container.
 *
 * Reads visibility, content, and overlay from **refs** so that the parent
 * GoogleProvider (9k lines) never needs to re-render just to update the
 * InfoBubble.  GoogleProvider triggers this component directly via the
 * `registerUpdate` callback (which stores `forceUpdate`).
 */
class InfoWindow extends React.Component {

  componentDidMount() {
    // Register a direct update trigger so GoogleProvider can re-render
    // only this component without going through its own render cycle.
    if (this.props.registerUpdate) {
      this.props.registerUpdate(() => this.forceUpdate());
    }
  }

  componentWillUnmount() {
    if (this.props.registerUpdate) {
      this.props.registerUpdate(null);
    }
  }

  render() {
    // Read from refs for instant updates (no parent re-render needed)
    const { openRef, contentRef, overlayRef, close, mapInstance, isClipCardRef } = this.props;
    const isClipCard = isClipCardRef?.current;
    const {messages} = this.props.intl

    const open = openRef?.current;
    const overlay = overlayRef?.current;
    const children = contentRef?.current;

    if (!open || !overlay || !overlay.container_) {
      return (
        <React.Fragment></React.Fragment>
      );
    }


    return ReactDOM.createPortal(
      <React.Fragment>
        {
          open
          &&
          <div className="info-window-container"
            onMouseEnter={() => { mapInstance && mapInstance.setOptions({draggable: false}); }}
            onMouseLeave={() => { mapInstance && mapInstance.setOptions({draggable: true}); }}
          >
            <div className={isClipCard ? "info-window-content clip-card" : "info-window-content"}>
              {this.props.loadingRef?.current && (
                <LinearProgress
                  sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 200, height: 3, borderRadius: '8px 8px 0 0' }}
                />
              )}
              <div className="info-window-close-button-container">
                <Button 
                  type="icon" 
                  tooltip={messages['close']}
                  placement="bottom" 
                  icon="close" 
                  size="small"
                  onClick={(e) => {
                    e.preventDefault();
                    if (close) close();
                  }}
                />
              </div>
              <div>
                {children}
              </div>
            </div>
          </div>
        }
      </React.Fragment>,
      overlay.container_
    );
  }
}

export default injectIntl(InfoWindow);
